import {useQuery} from '@tanstack/react-query';
import {
    getTotalChats,
    getOpenChats,
    getClosedChats,
    getChatsByDay,
    getAverageWaitTime,
    getAverageSatisfaction,
    getTopOperators,
    getLiveSnapshot,
    getLiveOperators,
} from './admin-dashboard-home-api';

// کنسول زنده‌ی ادمین: هر ۱۵ ثانیه تازه می‌شود. هر دو کوئری کلید ثابت دارند تا اگر
// چند صفحه هم‌زمان باز باشد، react-query یک درخواست مشترک بزند نه چند تا.
const LIVE_REFETCH_MS = 15000;

export const useTotalChats = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'total-chats', startDate || null],
        queryFn: () => getTotalChats(startDate),
        ...options,
    });
};


export const useOpenChats = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'open-chats', startDate || null],
        queryFn: () => getOpenChats(startDate),
        ...options,
    });
};


export const useClosedChats = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'closed-chats', startDate || null],
        queryFn: () => getClosedChats(startDate),
        ...options,
    });
};


export const useChatsByDay = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'chats-by-day', startDate || null],
        queryFn: () => getChatsByDay(startDate),
        ...options,
    });
};


export const useAverageWaitTime = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'average-wait-time', startDate || null],
        queryFn: () => getAverageWaitTime(startDate),
        ...options,
    });
};


export const useAverageSatisfaction = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'average-satisfaction', startDate || null],
        queryFn: () => getAverageSatisfaction(startDate),
        ...options,
    });
};


export const useTopOperators = (options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'top-operators'],
        queryFn: getTopOperators,
        ...options,
    });
};


export const useLiveSnapshot = (options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'live-snapshot'],
        queryFn: getLiveSnapshot,
        refetchInterval: LIVE_REFETCH_MS,
        ...options,
    });
};


export const useLiveOperators = (options = {}) => {
    return useQuery({
        queryKey: ['dashboard', 'live-operators'],
        queryFn: getLiveOperators,
        refetchInterval: LIVE_REFETCH_MS,
        ...options,
    });
};
